export const courseNameList = "COURSE_NAME_LIST";
export const courseDocumentList = "COURSE_DOCUMENT_LIST";
export const courseList = "COURSE_LIST";
export const courseRatingsList = "COURSE_RATINGS_LIST";
export const channelPartnerEnrolledCourseList = "CHANNEL_PARTNER_ENROLLED_COURSE_LIST";
export const channelPartnerCoursePendingEnrolledList = "CHANNEL_PARTNER_COURSE_PENDING_ENROLLED_LIST";
export const enrolledChannelPartnerListAgainstCourse = "ENROLLED_CHANNEL_PARTNER_LIST_AGAINST_COURSE";
